(function ($) {
	'use strict';

	$('.wp-block-pit-tabs-nav-item').on('click', function (e) {
		e.preventDefault();
		const parentTabs = $(this).parents('[data-tabs]');
		const currentTab = $(this).attr('id');

		// on vire la classe is-active sur tous
		parentTabs.find('.wp-block-pit-tabs-nav-item').not(this).removeClass('is-active').attr('aria-selected', 'false');
		parentTabs.find('[data-tab]').not('[data-tab="' + currentTab + '"]').removeClass('is-active');

		// on l'ajoute sur la nouvelle
		$(this).addClass('is-active');
		parentTabs.find('[data-tab="' + currentTab + '"]').addClass('is-active');

	})

})(jQuery);
